"use strict";

require("./registry.cjs");